import http from "@/http/aisea/axios";

const resourceForSignal = "/voyage_records";
const resourceVessel = `${resourceForSignal}/vessel`;
const resourceVessels = `${resourceForSignal}/vessels`;

export default {
  async fetchWakeByVesselId(payload) {
    const url = `${resourceVessels}/${payload.vesselId}/wake`;
    const now = new Date();
    // [NOTE] 24時間の航跡を取得
    const aDay = 24 * 60 * 60 * 1000;
    // [NOTE] INTERVALは外部ファイルに定義した方が良いかも
    // [TODO] 将来的にはzoom値に応じて変化できるようにする
    const INTERVAL = 20;
    let params = {
      interval: INTERVAL,
      started_at: new Date(now.getTime() - aDay),
      ended_at: now,
      vessel_id: payload.vesselId,
    };

    return await http.get(url, {
      params: params,
    });
  },

  async getLastPosition(vesselId) {
    return await this.getLastPositionWithTimeout(vesselId, 0);
  },

  async getLastPositionWithTimeout(vesselId, timeout = 5000) {
    const url = `${resourceVessel}/${vesselId}/last_position`;
    return await http.get(url, {
      timeout: timeout,
    });
  },
};
